/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { createContext, useContext, useEffect, useState } from "react";
import Auth from "../apis/auth"; // Your class in Auth.js

const AuthContext = createContext();
const auth = new Auth(); // Create instance of your Auth class

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(true);

    useEffect(() => {
        const checkSession = async () => {
            const isLoggedIn = await auth.checkAuth();
            setIsAuthenticated(isLoggedIn);
            setCheckingAuth(false);
        };
        checkSession();
    }, []);

    return (
        <AuthContext.Provider value={{ auth, isAuthenticated, setIsAuthenticated }}>
            {!checkingAuth && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
